import { defineComponent as w, useTemplateRef as B, computed as f, createBlock as p, openBlock as r, resolveDynamicComponent as c, mergeProps as $, unref as l, withCtx as a, createVNode as m, createElementBlock as b, createCommentVNode as v, createSlots as S, normalizeClass as n, createElementVNode as P, renderSlot as s, normalizeStyle as I } from "vue";
import o from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Label/label.js";
import { c_label__text_MaxWidth as L } from "../../node_modules/.pnpm/@patternfly_react-tokens@6.2.2/node_modules/@patternfly/react-tokens/dist/esm/c_label__text_MaxWidth.js";
import { useElementOverflow as A } from "../../use/index.js";
import M from "../Button.vue2.js";
import W from "../Tooltip/Tooltip.vue2.js";
import { useOUIAProps as E } from "../../helpers/ouia.js";
import { XmarkIcon as N } from "../../packages/icons/dist/esm/icons/xmark-icon.js";
import { LabelKey as O } from "./common.js";
import { useChildrenTracker as R } from "../../use/children-tracker.js";
const H = /* @__PURE__ */ w({
  name: "PfLabel",
  __name: "Label",
  props: {
    color: { default: "grey" },
    variant: { default: "filled" },
    status: {},
    tooltipPosition: { default: "top" },
    to: {},
    href: {},
    outline: { type: Boolean },
    compact: { type: Boolean },
    overflow: { type: Boolean },
    textMaxWidth: {},
    closeBtnAriaLabel: { default: "Close" },
    onClose: {},
    onClick: {},
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  },
  setup(y) {
    const C = {
      blue: o.modifiers.blue,
      teal: o.modifiers.teal,
      green: o.modifiers.green,
      orange: o.modifiers.orange,
      purple: o.modifiers.purple,
      red: o.modifiers.red,
      orangered: o.modifiers.orangered,
      yellow: o.modifiers.yellow,
      grey: ""
    }, t = y, k = E({ id: t.ouiaId, safe: t.ouiaSafe });
    R(O);
    const h = B("textRef"), g = A(h), u = f(() => t.onClick && !t.overflow), d = f(() => (t.href || t.onClick) && t.disabled), i = f(() => t.href ? "a" : t.to ? "router-link" : u.value ? "button" : "span");
    return (e, T) => (r(), p(c(e.overflow ? "button" : "span"), $(l(k), {
      type: e.overflow ? "button" : void 0,
      class: [l(o).label, C[e.color], {
        [l(o).modifiers.filled]: e.variant === "filled",
        [l(o).modifiers.outline]: e.outline || e.variant === "outline",
        [l(o).modifiers.compact]: e.compact,
        [l(o).modifiers.overflow]: e.overflow
      }]
    }), {
      default: a(() => [
        m(W, { position: e.tooltipPosition }, S({
          default: a(() => [
            (r(), p(c(i.value), {
              to: e.to,
              href: e.href,
              type: i.value === "button" ? "button" : void 0,
              disabled: i.value === "button" && d.value ? !0 : void 0,
              "aria-disabled": i.value === "a" && d.value ? !0 : void 0,
              class: n([l(o).labelContent, { [l(o).modifiers.clickable]: u.value }])
            }, {
              default: a(() => [
                e.$slots.icon ? (r(), b("span", {
                  key: 0,
                  class: n(l(o).labelIcon)
                }, [
                  s(e.$slots, "icon")
                ], 2)) : v("", !0),
                P("span", {
                  ref: "textRef",
                  class: n(l(o).labelText),
                  style: I(e.textMaxWidth ? { [l(L).name]: e.textMaxWidth } : void 0)
                }, [
                  s(e.$slots, "default")
                ], 6)
              ]),
              _: 3
            }, 8, ["to", "href", "type", "disabled", "aria-disabled", "class"]))
          ]),
          _: 2
        }, [
          l(g) ? {
            name: "content",
            fn: a(() => [
              s(e.$slots, "default")
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["position"]),
        e.onClose || e.$slots.actions ? (r(), b("span", {
          key: 0,
          class: n(l(o).labelActions)
        }, [
          s(e.$slots, "actions", {}, () => [
            m(M, {
              variant: "plain",
              "no-padding": "",
              "aria-label": e.closeBtnAriaLabel,
              disabled: d.value ? !0 : void 0,
              onClick: e.onClose
            }, {
              icon: a(() => [
                m(l(N))
              ]),
              _: 1
            }, 8, ["aria-label", "disabled", "onClick"])
          ])
        ], 2)) : v("", !0)
      ]),
      _: 3
    }, 16, ["type", "class"]));
  }
});
export {
  H as default
};
